(function() {
    'use strict';

    angular
        .module('app')
        .directive('collection', collection);

    //collection.$inject = ['$window'];
    
    function collection () {
        // Usage:
        //     <collection></collection>
        // Creates:
        // 
        return {
            restrict: "E",
            replace: true,
            link: link,
            scope: {
                collection: '=',
                onClicked: '=',
                showFolder: '=',
                mode: '='
            },
            template: "<div class='tree-list'><member mode='mode' show-folder='showFolder' ng-repeat='member in collection track by member.uniqueId' member='member' on-clicked='itemClicked'></member></div>"
        }

        function link(scope, elem, attr) {
            scope.itemClicked = function (item, doubleClick, event) {
                if (scope.onClicked) {
                    scope.onClicked(item, doubleClick);
                }
            }
        }
    }

})();